import './auto-pay-switch.css'
const AutoPaySwitch = ({studentModal, editStudentInfo}) => {
    return (
        <div className='student-modal__auto-pay-switch__wrapper'>
            {studentModal.autoPay ? 
                <svg className="auto-pay-switch-svg" viewBox="0 0 512 512" onClick={(e) => editStudentInfo("index-placeholder", "autoPay", false, studentModal.familyId)}>
                    <g>
                        <g>
                            <path fill="green" d="M376.5,120.5h-241C60.785,120.5,0,181.285,0,256s60.785,135.5,135.5,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                S451.215,120.5,376.5,120.5z M376.5,361.5C318.327,361.5,271,314.174,271,256c0-58.172,47.327-105.5,105.5-105.5
                                c58.173,0,105.5,47.328,105.5,105.5C482,314.174,434.673,361.5,376.5,361.5z"/>
                        </g>
                    </g>
                </svg>
                :
                <svg className="auto-pay-switch-svg" viewBox="0 0 511.999 511.999" onClick={(e) => editStudentInfo("index-placeholder", "autoPay", true, studentModal.familyId)}>
                    <g>
                        <g>
                            <path fill="#8EAAAF" d="M376.499,120.5h-241C60.784,120.5,0,181.286,0,256s60.784,135.5,135.499,135.5h241c74.715,0,135.5-60.785,135.5-135.5
                                S451.214,120.5,376.499,120.5z M135.499,361.501C77.326,361.501,30,314.173,30,256c0-58.173,47.326-105.5,105.499-105.5
                                c58.173,0,105.5,47.327,105.5,105.5C240.999,314.173,193.672,361.501,135.499,361.501z"/>
                        </g>
                    </g>
                </svg>
            }
            <div className='auto-pay-switch__label'>Auto-Pay</div>
        </div>
    )
}
export default AutoPaySwitch